import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { buildLoginPath, buildPathWithSlug } from '../../helpers/commandCentreRouting';

const LegacyRouteRedirect: React.FC<{ basePath: string }> = ({ basePath }) => {
  const location = useLocation();
  const { login_unique_id } = useParams<{ login_unique_id?: string }>();

  const target =
    basePath === '/login'
      ? buildLoginPath(login_unique_id, location.search)
      : buildPathWithSlug(basePath, login_unique_id, location.search);

  return <Navigate to={target} replace />;
};

export default LegacyRouteRedirect;
